import { useEffect } from 'react';

function PageHead({ title }: { title: string }) {
  useEffect(() => {
    document.title = `${title} - LIO Insurance`;
    return () => {
      document.title = 'LIO Insurance';
    };
  }, [title]);

  return null;
}

export default PageHead;
